/* eslint-disable @typescript-eslint/no-explicit-any */
import EmptyState from 'app/components/EmptyState/EmptyState';
import FilterBarComponent from 'app/components/FilterBarComponent/FilterBarComponent';
import Pagination from 'app/components/Pagination/Pagination';
import TableItem from 'app/components/TableItem/TableItem';
import { loadingTextLabelInit, userPortofolioEmptyState, userPortofolioFilterEmptyState, UserPortofolioFilterForm } from 'app/configs/userPortofolio.config';
import { IEmptyState } from 'app/interfaces/empty-state/empty-state.interface';
import { UserPortofolioDetailInterface, UserPortofolioDetailListInterface } from 'app/interfaces/lender/UserPortofolioDetailInterface';
import { ISubTextLabel, ITableItem } from 'app/interfaces/table-item/table-item.interface';
import { ITextLabel } from 'app/interfaces/text-label/textLabel.interface';
import { getUserPortofolioDetailAction, getUserPortofolioListAction } from 'app/redux/actions/UserPortofolioAction';
import { IPagination } from 'app/redux/reducers/PortofolioReducer';
import { UserPortofolioListItem } from 'app/redux/reducers/UserPortofolioReducer';
import { RootState } from 'app/redux/store';
import { datePipe } from 'app/utils/DatePipe';
import rupiahCurrencyFormatter from 'app/utils/RupiahPipe';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './UserPortofolioPage.scss';

export const tableItemsState: ITableItem[] = [
    {
        id: 'shimmering1',
        textLabel: loadingTextLabelInit,
        subTextLabel: []
    },
    {
        id: 'shimmering2',
        textLabel: loadingTextLabelInit,
        subTextLabel: []
    },
    {
        id: 'shimmering3',
        textLabel: loadingTextLabelInit,
        subTextLabel: []
    }
];
export const paginationInit: IPagination = {
	totalData: 0,
	totalPage: 0,
	page: 1,
};

export const portofolioDataState = {
	tableItems: tableItemsState
};

const portos: UserPortofolioListItem[] = [];

const UserPortofolioPage = function init():React.ReactElement {
    const dispatch = useDispatch();
    const userPortofolioState = useSelector((state: RootState) => state.userPortofolioReducer);
    const [userPortofolio, setUserPortos] = useState(portos);
    const [page, setPage] = useState(1);
    const [userPortoTextLabel, setUserPortoTextLabel] = useState(portofolioDataState.tableItems);
    const [localPagination, setPagination] = useState(paginationInit);
    const [borrowerId, setBorrowerId] = useState('');
    const { userPortofolioList, userPortofolioDetail, pagination, loading } = userPortofolioState;

    function getQueryParam(paramsName: string): string {
		const windowUrl = window.location.search;
		const params = new URLSearchParams(windowUrl);
		return params.get(paramsName) || '';
	}

    function filterOnSubmit(payload: Record<string, string | number>):void {
        const request = {
			name: String(payload.name),
			limit: 10,
			page: 1
		};
        setPage(1);
        dispatch(getUserPortofolioListAction(request));
    }

    function tableDropdownOnClick(payload: UserPortofolioListItem): void {
        if (payload.subTextLabel.length === 0) {
            setBorrowerId(payload.borrowerId);
            dispatch(getUserPortofolioDetailAction(
                { borrowerId: payload.borrowerId, page: 1, limit: 6 }
            ));
        }
    }

    function renderEmptyState(): React.ReactElement {
        const windowUrl = window.location.search;
        const emptyState: IEmptyState = windowUrl
                            ? userPortofolioFilterEmptyState
                            : userPortofolioEmptyState;
        return (
            <EmptyState
                image={emptyState.image}
                placeholder={emptyState.placeholder}
                caption={emptyState.caption}
            />
        );
    }

    function detailReachBottomHandle(payload: UserPortofolioListItem): void {
        const { detailPagination } = payload;
        setBorrowerId(payload.borrowerId);
        if (detailPagination && page <= detailPagination.totalPage) {
            const nextPage = page + 1;
            dispatch(getUserPortofolioDetailAction(
                { borrowerId: payload.borrowerId, page: nextPage, limit: 6 }
            ));
        }
    }

    useEffect(() => {
        const payload = {
			name: getQueryParam('name'),
			limit: 10,
			page: Number(getQueryParam('page')) || 1
		};
        dispatch(getUserPortofolioListAction(payload));
    }, [page]);

    useEffect(() => {
		setPage(Number(getQueryParam('page')) || 1);
		if (userPortofolioList) {
			setUserPortos(userPortofolioList);
			setPagination(pagination);
		}
	}, [userPortofolioList]);

    useEffect(() => {
        if (!loading) {
            const tableData: UserPortofolioListItem[] = [];
            userPortofolio.forEach((each: UserPortofolioListItem, index) => {
                const textLabel: ITextLabel[] = [
                    {
						title: 'Nama',
						value: each.borrowerName,
						bg: false,
                        width: '40'
					},
					{
						title: 'Jumlah Pinjaman aktif',
						value: rupiahCurrencyFormatter(each.activeLoanAmount),
						bg: false,
					},
					{
						title: 'Jumlah Pembayaran',
						value: rupiahCurrencyFormatter(each.paidAmount),
						bg: false,
					},
					{
						title: 'Jumlah Pinjaman Total',
						value: rupiahCurrencyFormatter(each.totalLoanAmount),
						bg: false,
					},
                ];
                const tableItems: UserPortofolioListItem = {
                    ...each,
                    showToggleButton: true,
					textLabel,
					subTextLabel: [],
                    id: `Item${String(index)}`,
                    detailPagination: paginationInit
				};
                tableData.push(tableItems);
            });
            setUserPortoTextLabel(tableData);
        }
    }, [userPortofolio, userPortofolioList]);

    useEffect(() => {
        if (!loading) {
            const detail: UserPortofolioDetailInterface = userPortofolioDetail;
            if (detail) {
                const porto = userPortoTextLabel
                        .find((item: any) => item.borrowerId === borrowerId);
                detail.detailList.forEach((each: UserPortofolioDetailListInterface) => {
                    const data: ITextLabel[] = [
                        {
                            title: 'No Pinjaman',
                            value: each.loanNumber,
                            bg: false
                        },
                        {
                            title: 'Tanggal Pendanaan',
                            value: datePipe(each.fundingDate),
                            bg: false
                        },
                        {
                            title: 'Nilai Pinjaman',
                            value: rupiahCurrencyFormatter(each.loanAmount),
                            bg: false
                        },
                    ];
                    const tableItems: ISubTextLabel = {
                        textLabel: data,
                        loanStatusName: each.loanStatusName
                    };

                    if (porto) {
                        if (porto.subTextLabel.length < userPortofolioDetail.pagination.totalData) {
                            porto.subTextLabel.push(tableItems);
                            porto.detailPagination = detail.pagination;
                        }
                    }
                });
                const temp = [...userPortoTextLabel];
                setUserPortoTextLabel(temp);
            }
        }
    }, [userPortofolioDetail]);

    return (
        <div>
            <FilterBarComponent
                formField={UserPortofolioFilterForm}
                loading={loading}
                onSubmit={(payload: Record<string, string | number>) => filterOnSubmit(payload)}
            />
            <div className="userPortofolioTable">
                {userPortoTextLabel && userPortoTextLabel.map((each: ITableItem, index) => (
                    <TableItem
                        // eslint-disable-next-line react/no-array-index-key
                        key={index}
                        loading={loading}
                        tableData={each}
                        dropdownOnClick={
                            (payload: UserPortofolioListItem) => tableDropdownOnClick(payload)
                        }
                        detailReachBottom={
                            (payload: UserPortofolioListItem) => detailReachBottomHandle(payload)
                        }
						additionalButton={false}
                    />
                ))}
            </div>
            { !loading && userPortofolioList.length === 0 && (
                renderEmptyState()
            )}
            { localPagination.totalPage > 1
				&& <Pagination page={page} setPage={setPage} totalPage={localPagination.totalPage} />}
        </div>
    );
};

export default UserPortofolioPage;
